<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row page__row_between">
        <div class="page__item">
          <h1 class="title">Должности</h1>
        </div>
        <div class="page__item">
          <AppButtonSmAdd title="Создать" @click.native="showCreateModal" />
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row mb-20" v-if="positions.length !== 0">
        <AppTable :data="positions"
                  :headers="tableHeaders"
                  :isMenuControlsActive="roleAccessRemove"
                  @show-this-item="showUpdateModal"
                  @toggle-controls="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="В разделе еще нет ни одной записи"/>
        </div>
      </div>
    </section>

    <section class="section page__footer directory-list__footer">
      <div class="page__row">
        <!--место для пагинации-->
      </div>
    </section>

    <transition-group name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       key="remove-confirmation"
                       text="Вы действительно хотите удалить эту должность?"
                       @confirm="removeItem"
                       @reject="closeModals"
      />
      <ItemUpdateModal v-if="updateModal.active"
                       key="update-modal"
                       title="Редактировать должность"
                       :item="updateModal.position"
                       :name-validation="updateModal.validation"
                       @set-item-name="setItemUpdatedName"
                       @update-item="updateItem"
                       @close-modal="closeModals"
      />
      <ItemCreateModal v-if="createModal.active"
                       key="create-modal"
                       title="Создать должность"
                       :value="createModal.newPositionName"
                       :name-validation="createModal.validation"
                       @set-item-name="setNewItemName"
                       @create-item="createItem"
                       @close-modal="closeModals"
      />
    </transition-group>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import AppTable from '../../../components/page/table/AppTable'
import AppConfirmation from '../../../components/page/modal/AppConfirmation'
import AppButtonSmAdd from '../../../components/page/button/AppButtonSmAdd'
import ThePagePreloader from '../../../components/page/ThePagePreloader'
import ItemUpdateModal from '../../../components/page/modal/itemUpdateModal'
import ItemCreateModal from '../../../components/page/modal/itemCreateModal'
import AppNoRecordsPlaceholder from '../../../components/page/text/AppNoRecordsPlaceholder'

export default {
  name: 'PositionList',
  components: {
    AppNoRecordsPlaceholder,
    ItemCreateModal,
    ItemUpdateModal,
    ThePagePreloader,
    AppButtonSmAdd,
    AppConfirmation,
    AppTable
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null
      }
    }
  },
  computed: {
    positions () {
      const positions = this.$store.getters.positions
      const positionsData = []
      for (let i = 0; i < positions.length; ++i) {
        positionsData.push({
          id: positions[i].id,
          isControlsActive: positions[i].isControlsActive,
          values: [
            positions[i].name
          ]
        })
      }
      return positionsData
    },
    isLoading () {
      return this.$store.getters.positionListIsLoading
    },
    tableHeaders () {
      return this.$store.getters.positionListTableHeaders
    },
    updateModal () {
      return this.$store.getters.positionListUpdateModal
    },
    createModal () {
      return this.$store.getters.positionListCreateModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('togglePositionListItemControls', itemId)
    },
    showCreateModal () {
      this.$store.dispatch('showPositionListCreateModal')
    },
    setNewItemName (name) {
      this.$store.dispatch('setCreatedPositionName', name)
      this.$store.dispatch('clearPositionListModalValidation')
    },
    createItem () {
      this.$store.dispatch('createPosition')
    },
    showUpdateModal (itemId) {
      this.$store.dispatch('showPositionListUpdateModal', itemId)
    },
    setItemUpdatedName (name) {
      this.$store.dispatch('setUpdatedPositionName', name)
      this.$store.dispatch('clearPositionListModalValidation')
    },
    updateItem () {
      this.$store.dispatch('updatePosition')
    },
    showRemoveConfirmation (itemId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = itemId
    },
    removeItem () {
      this.$store.dispatch('deletePosition', this.removeConfirmation.id)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    closeModals () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.$store.dispatch('closePositionListModals')
      this.$store.dispatch('clearPositionListModalValidation')
    }
  },
  mounted () {
    this.$store.dispatch('getPositions')
  }
}
</script>

<style lang="scss" scoped>
.directory-list {
  &__footer {
    padding-bottom: 110px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
